module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Playade-Somo-ad6b5e7a8bd0c46577cc86e4293101a3.jpg";